import type { CreateFirmOnboardingFormLink } from '@cloudFunctions/types/clientToFirmPayments/createFirmOnboardingFormLink';
import type { BackendRouteDefinition } from '../types';

// Split the stable frontend request shape into the HTTP path/body pieces so the
// existing wrapper signature can stay unchanged while transport flips to api.
export const createFirmOnboardingFormLinkRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/onboarding/forms/:onboardingFormId/link',
  params: ({ onboardingFormId }: CreateFirmOnboardingFormLink.RequestData) => ({
    onboardingFormId,
  }),
  body: ({
    environment,
    linkDetails,
  }: CreateFirmOnboardingFormLink.RequestData) => ({
    environment,
    linkDetails,
  }),
} as const satisfies BackendRouteDefinition;
